<template>
  <Category cate-name="asset-stock" category-name="資産運用（株式）" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
